function sendGtmEvent(payload: { event: string; [key: string]: string }) {
  if ('dataLayer' in window && Array.isArray(window.dataLayer)) {
    window.dataLayer.push(payload);
  }
}

export function emitAddPropertyEvent() {
  sendGtmEvent({ event: 'RentalManager::AddProperty' });
}

export function emitRentZestimateEvent() {
  sendGtmEvent({ event: 'RentZestimate' });
}
